import React, { useState, memo } from 'react';
import { Card, makeStyles } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import Highlight, { defaultProps } from 'prism-react-renderer';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import Scrollbar from '../Scrollbar';
import clsx from 'clsx';
import { highlightTheme } from './highlightTheme';
import Box from '@material-ui/core/Box';
import { Fonts } from '../../../shared/constants/AppEnums';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '0px !important',
    },
    borderRadius: 8,
    backgroundColor: theme.palette.background.default,
    height: '100%', // Ensure full height
  },
  cardContent: {
    padding: 0, // Remove default padding
    height: '100%', // Full height
  },
  scrollbarContainer: {
    height: '100%', // Ensure scrollbar takes full height
  },
  componentContainer: {
    width: '100%',
    height: '100%', // Ensure full height
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const ComponentCard = memo(({
  title = '',
  maxHeight = 1000,
  description = '',
  component: Component,
  source,
}) => {
  const [viewSource, setViewSource] = useState(false);
  const [animation, setAnimation] = useState(false);

  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.cardContent}>
        <Collapse in={animation}>
          {viewSource && source && (
            <Scrollbar
              style={{
                borderRadius: 8,
                background: '#333333',
              }}>
              <Highlight
                {...defaultProps}
                code={source}
                language='jsx'
                theme={highlightTheme}>
                {({className, style, tokens, getLineProps, getTokenProps}) => (
                  <pre
                    className={clsx(className)}
                    style={{...style, maxHeight: 500}}>
                    {tokens.map((line, i) => (
                      <Box key={i} {...getLineProps({line, key: i})}>
                        {line.map((token, key) => (
                          <span key={key} {...getTokenProps({token, key})} />
                        ))}
                      </Box>
                    ))}
                  </pre>
                )}
              </Highlight>
            </Scrollbar>
          )}
        </Collapse>
        <Scrollbar 
          className={classes.scrollbarContainer} 
          style={{maxHeight: maxHeight}}
        >
          <Box className={classes.componentContainer}>
            <Component />
          </Box>
        </Scrollbar>
      </CardContent>
    </Card>
  );
});

ComponentCard.propTypes = {
  component: PropTypes.elementType.isRequired,
  source: PropTypes.string,
  title: PropTypes.node,
  description: PropTypes.node,
  maxHeight: PropTypes.number,
};

export default ComponentCard;